export function formattedPriceUtils(price, currency = 'EUR', convertMode) {

    const exchangeRate = 1.95583; // Фиксиран курс BGN към EUR
    const date = new Date('2026-01-01');
    let result;

    if (parseInt(convertMode) === 1 || date < new Date()) {
        if (currency === 'EUR') {
            result = price;
        } else {
            result = price * exchangeRate;
        }
    } else {
        if (currency === 'BGN') {
            result = price;
        } else {
            result = price / exchangeRate;
        }
    }

    return new Intl.NumberFormat('bg-BG', {style: 'currency', currency}).format(result);
}